<template>
  <parent>
    <loading-page v-if="loading" />

    <div
      v-else
      class="image-policies-info h-100"
    >
      <form-wrapper full-width>
        <template v-slot:body>
          <paper>
            <template v-slot:title>
              <p class="mb-0">
                Info
              </p>
            </template>
            <div class="px-2 col-12 col-lg-6 m-auto">
              <div class="information">
                <label>Name</label>
                <p class="info">
                  {{ imagePolicy.name || '-' }}
                </p>
              </div>
              <div class="information">
                <label>Comment</label>
                <p class="info">
                  {{ imagePolicy.comment || '-' }}
                </p>
              </div>
            </div>
          </paper>

          <paper>
            <template v-slot:title>
              <p class="mb-0">
                Resize              </p>
            </template>
            <div class="px-2 col-12 col-lg-6 m-auto">
              <div class="d-flex">
                <div class="information w-50">
                  <label>Width</label>
                  <p class="info">
                    {{ imagePolicy.processingOptions.width }}
                  </p>
                </div>

                <div class="information w-50">
                  <label>Height</label>
                  <p class="info">
                    {{ imagePolicy.processingOptions.height }}
                  </p>
                </div>
              </div>

              <div class="d-flex">
                <div class="information w-50">
                  <label>Resize</label>
                  <p class="info">
                    {{ getResizeLabel(imagePolicy.processingOptions.resize) }}
                  </p>
                </div>
                <div class="information w-50">
                  <label>Gravity</label>
                  <p class="info">
                    {{ getGravityLabel(imagePolicy.processingOptions.gravity) }}
                  </p>
                </div>
              </div>
              <div class="d-flex">
                <div class="information w-50">
                  <label>Enlarge</label>
                  <p class="info">
                    {{ capitalizeFirstLetter(`${imagePolicy.processingOptions.enlarge}`) }}
                  </p>
                </div>
              </div>
            </div>
          </paper>

          <paper>
            <template v-slot:title>
              <div>
                <p class="mb-0">
                  Filters
                </p>
              </div>
            </template>
            <div class="px-2 col-12 col-lg-6 m-auto">
              <div class="d-flex">
                <div class="information w-50">
                  <label>Blur</label>
                  <p class="info">
                    {{ imagePolicy.processingOptions.blur }}
                  </p>
                </div>

                <div class="information w-50">
                  <label>Sharpen</label>
                  <p class="info">
                    {{ imagePolicy.processingOptions.sharpen }}
                  </p>
                </div>
              </div>
            </div>
          </paper>
          <paper>
            <template v-slot:title>
              <div>
                <p class="mb-0">
                  Output Settings
                </p>
              </div>
            </template>
            <div class="px-2 col-12 col-lg-6 m-auto">
              <div class="d-flex">
                <div class="information w-50">
                  <label>Quality</label>
                  <p class="info">
                    {{ imagePolicy.processingOptions.quality }}
                  </p>
                </div>

                <div class="information w-50">
                  <label>Format</label>
                  <p class="info">
                    {{ getFormatLabel(imagePolicy.processingOptions.format) }}
                  </p>
                </div>
              </div>
            </div>
          </paper>
        </template>

        <template v-slot:footer>
          <b-button
            v-if="goBack"
            variant="bg-white"
            @click="onGoBack()"
          >
            Go Back
          </b-button>
        </template>
      </form-wrapper>
    </div>
  </parent>
</template>
<script>
import Paper from '@/components/paper/Paper.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'ImagePoliciesInfo',
  components: {
    Paper,
  },
  data() {
    return {
      policyId: null,
      goBack: false,
      formatOptions: [
        { value: '', label: 'None' },
        { value: 'webp', label: 'WebP' },
        { value: 'jpeg', label: 'JPEG' },
        { value: 'png', label: 'PNG' },
        { value: 'gif', label: 'GIF' },
        { value: 'avif', label: 'AVIF' },
      ],
      resizeOptions: [
        { value: '', label: 'None' },
        { value: 'auto', label: 'Auto' },
        { value: 'fit', label: 'Fit' },
        { value: 'fill', label: 'Fill' },
      ],
      gravityOptions: [
        { label: 'None', value: '' },
        { label: 'Smart', value: 'sm' },
        { label: 'Center', value: 'ce' },
        { label: 'North (top edge)', value: 'no' },
        { label: 'South (bottom edge)', value: 'so' },
        { label: 'East (right edge)', value: 'ea' },
        { label: 'West (left edge)', value: 'we' },
        { label: 'North-east (top-right corner)', value: 'noea' },
        { label: 'North-west (top-left corner)', value: 'nowe' },
        { label: 'South-east (bottom-right corner)', value: 'soea' },
        { label: 'South-west (bottom-left corner)', value: 'sowe' },
      ],
    }
  },
  computed: {
    imagePolicy() {
      return this.$store.state.imagePolicies.imagePolicy
    },
    loading() {
      return this.$store.state.imagePolicies.gettingPolicy
    },
  },
  created() {
    this.policyId = this.$route.params.imageId
    this.$store
      .dispatch('imagePolicies/getImagePolicy', this.policyId)
      .catch(err => redirectError(err, this.$router, this.$route.path))
    this.goBack = this.$route.query.v !== undefined
  },
  methods: {
    onGoBack() {
      this.$router.push({ name: 'image-policies' })
    },
    getGravityLabel(value) {
      const gravityOption = this.gravityOptions.find(option => option.value === value)
      return gravityOption ? gravityOption.label : '-'
    },
    getFormatLabel(value) {
      const formatOption = this.formatOptions.find(option => option.value === value)
      return formatOption ? formatOption.label : '-'
    },
    getResizeLabel(value) {
      const resizeOption = this.resizeOptions.find(option => option.value === value)
      return resizeOption ? resizeOption.label : '-'
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },

  },
}
</script>
